import { mdiChartBellCurveCumulative } from '@mdi/js'

export default [
  {
    title: 'REPORT',
    icon: mdiChartBellCurveCumulative,
    to: 'dashboard-crm',
  },
]
